module.exports = __webpack_public_path__ + "img/kiwoom_main_left1.906ca290.png";